import { PersonAvatarStroke } from './PersonAvatarStroke'

interface PersonAvatarProps {
  name: string
  avatarUrl: string
  avatarBg: string
  avatarStrokeColor: string
  avatarStrokeRotate?: string
}

export const PersonAvatar = ({
  name,
  avatarUrl,
  avatarBg,
  avatarStrokeColor,
  avatarStrokeRotate,
}: PersonAvatarProps) => {
  const getInitials = (name: string) => {
    if (!name) {
      return 'NA'
    }
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
  }

  return (
    <div className='relative'>
      {avatarUrl ? (
        <div
          style={{ backgroundImage: `url(${avatarUrl})` }}
          className='border-4 border-[#DDE3FB] w-8 h-8 lg:w-20 lg:h-20 rounded-full bg-contain bg-center bg-no-repeat'
          aria-label='profile photo'
        />
      ) : (
        <p
          className={`text-xs lg:text-base flex items-center justify-center border-4 border-[#DDE3FB] w-8 h-8 lg:w-20 lg:h-20 rounded-full ${avatarBg}`}
        >
          {getInitials(name)}
        </p>
      )}
      <PersonAvatarStroke
        className={`absolute -top-[4px] -left-[4px] w-10 h-10 lg:-top-[8px] lg:-left-[9px] lg:w-24 lg:h-24 ${avatarStrokeRotate} ${avatarStrokeColor}`}
      />
    </div>
  )
}
